import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { GetEntityConnectionGQL, GetEntityNotesGQL, NoteTarget } from 'generated/graphql';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetNotesService {

  /**
   * Helper for determining is a user can remove or update a note.
   */
  constructor(
    private _getEntityNotesGQL: GetEntityNotesGQL,
    private _getConnectionById: GetEntityConnectionGQL,
  ) {
  }

  getNotes(targetType: NoteTarget, targetId: string, campaignId: string) {
    if (targetType === NoteTarget.Entity) {
      return this._getEntityNotesGQL.watch({
        campaignId,
        entityId: targetId
      }).valueChanges.pipe(
        map(({ data }) => data.getEntity.notes)
      );
    }

    if (targetType === NoteTarget.EntityConnection) {
      return this._getConnectionById.watch({
        campaignId,
        entityConnectionId: targetId
      }).valueChanges.pipe(
        map(({ data }) => data.getEntityConnection.notes)
      );
    }

    if (targetType === NoteTarget.TaggableLogbook) {
      console.warn('NoteTarget.TaggableLogbook not implemented');
      return of([]);
    }
  }
}
